/**
 * useRole Hook
 * Provides role and permission checking utilities
 */

import { useAuth } from './useAuth'
import { UserRole, Permission } from '../types/auth'
import { hasRole, hasPermission, isAdmin, isUser } from '../utils/permissions'

export function useRole() {
  const { role, user, admin } = useAuth()

  return {
    role,
    user,
    admin,
    isAdmin: () => isAdmin(role),
    isUser: () => isUser(role),
    hasRole: (requiredRole: UserRole | UserRole[]) => hasRole(role, requiredRole),
    hasPermission: (permission: Permission) => hasPermission(user || admin, role, permission),
  }
}

/**
 * Hook to require specific role
 * Throws error if used outside component with required role
 */
export function useRequireRole(requiredRole: UserRole | UserRole[]) {
  const { role } = useAuth()
  
  if (!hasRole(role, requiredRole)) {
    throw new Error(`This component requires role: ${Array.isArray(requiredRole) ? requiredRole.join(' or ') : requiredRole}`)
  }
  
  return { role }
}

